import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";

function App() {
  //removing all the errors from the browser console
  console.warn = console.error = () => { };

  return (
    <BrowserRouter>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <AppRoutes />
      </MsalAuthenticationTemplate>
    </BrowserRouter>
  );
}

export default App;
